import { Button, Theme } from "@mui/material";
import { MouseEventHandler, ReactElement } from "react";
import { BarekamIcon, IconVariants } from "../icon/barekam-icon";
import {
  ActionButton,
  ActionButtonFilledCard,
  ActionButtonSmall,
  CancelButtonSmall,
  RemoveButtonSmall,
} from "./styled/action";
import {
  ChipClearAll,
  FilterButton,
  FilterButtonOpened,
  FilterButtonSecondary,
  FilterButtonSecondaryOpened,
} from "./styled/filter";
import {
  HeaderButton,
  HeaderButtonSelected,
  MyAddressesButton,
  MyAddressesCopyButton,
  NewHomeWhiteButton,
} from "./styled/header";
import { AuthButton, AuthTypeSelectButton } from "./styled/login";
import {
  ReceivedButtonLarge,
  ReceivedButtonSelectedLarge,
  ReceivedButtonSelectedSmall,
  ReceivedButtonSmall,
  SentButtonLarge,
  SentButtonSelectedLarge,
} from "./styled/navigation";
import {
  DashboardButton,
  StateButton,
  StateButtonSelected,
  TabButton,
  TabButtonSelected,
} from "./styled/sidebar-filter";
import {
  NewOrderAddButton,
  NewOrderAddButtonSmall,
  OrderAddProductButton,
  OrderExportButton,
  OrderPopupPayButton,
  OrderSummaryButton,
  OrderSummaryButtonDisabled,
  OrderWarehouseCardButton,
} from "./styled/orders";
import { RecipientEditButton } from "./styled/new-recipient";
import { InputWithSelectButton } from "./styled/input-with-select";
import {
  LinkButton,
  TermsAndConditionsButton,
  TextButton,
} from "./styled/simple";
import { CalendarButton, CalendarButtonSelected } from "./styled/calendar";
import {
  ParcelEditAddDescriptionButton,
  ParcelEditCreateNewOrderButton,
  ParcelEditDefaultButton,
  ParcelEditRemoveButton,
  ParcelEditToAntherOrderButton,
} from "./styled/parcel-edit";
import {
  DefaultNewOrderSelectedButton,
  NewOrderChooseButton,
  NewOrderProceedButton,
} from "./styled/additional-serivce";
import { CalculateButton } from "./styled/calculate";
import {
  ActionbarButtons,
  AdditionalServiceButtons,
  AddressCardButtons,
  AuthButtons,
  BalanceButtons,
  CalculateButtons,
  CalendarButtons,
  DialogButtons,
  FilterButtons,
  HeaderButtons,
  MonthlyLimitsButtons,
  NewHomeButtons,
  OrderButtons,
  ParcelEditButtons,
  RecipientButtons,
  SidebarButtons,
  SimpleButtons,
} from "./index";
import { NewAddressAddButton } from "./styled/address-card";
import {
  MonthlyLimitsRemoveButton,
  MonthlyLimitsSetButton,
} from "./styled/monthly-limits";
import { SxProps } from "@mui/system/styleFunctionSx";
import { NewCardButton, NewCardButtonSelected } from "./styled/balance";
import {
  DialogCancelButton,
  DialogDeleteButton,
  DialogOkButton,
  DialogSaveButton,
} from "./styled/dialog";

const BarekamButton = (props: BarekamButtonProps) => {
  const {
    type,
    onClick,
    children,
    selected,
    size,
    disabled,
    sx,
    startIcon,
    endIcon,
    className,
  } = props;

  switch (type) {
    case "received":
      switch (size) {
        default:
        case "l":
          return selected ? (
            // TODO: disabled until sent tab is added
            <ReceivedButtonSelectedLarge
              onClick={onClick}
              children={children}
              disabled
              sx={sx}
            />
          ) : (
            <ReceivedButtonLarge
              onClick={onClick}
              children={children}
              disabled
              sx={sx}
            />
          );
        case "s":
          return selected ? (
            <ReceivedButtonSelectedSmall
              onClick={onClick}
              children={children}
              disabled
              sx={sx} 
              className={className}
            />
          ) : (
            <ReceivedButtonSmall
              onClick={onClick}
              children={children}
              className={className}
              disabled
              sx={sx}
            />
          );
      }
    case "sent":
      switch (size) {
        default:
        case "l":
          return selected ? (
            <SentButtonSelectedLarge
              onClick={onClick}
              children={children}
              sx={sx}
            />
          ) : (
            <SentButtonLarge onClick={onClick} children={children} sx={sx} />
          );
        case "s":
          return selected ? (
            <ReceivedButtonSelectedSmall
              onClick={onClick}
              children={children}
              sx={sx}
            />
          ) : (
            <ReceivedButtonSmall
              onClick={onClick}
              children={children}
              sx={sx}
            />
          );
      }
    case SidebarButtons.ITEM:
      return selected ? (
        <StateButtonSelected onClick={onClick} children={children} sx={sx} />
      ) : (
        <StateButton onClick={onClick} children={children} sx={sx} />
      );
    case SidebarButtons.DASHBOARD:
      return selected ? (
        <StateButtonSelected onClick={onClick} children={children} sx={sx} />
      ) : (
        <DashboardButton onClick={onClick} children={children} sx={sx} />
      );
    case "tab": // TODO: move to group
      return selected ? (
        <TabButtonSelected onClick={onClick} children={children} sx={sx} />
      ) : (
        <TabButton onClick={onClick} children={children} sx={sx} />
      );
    case HeaderButtons.SIMPLE:
      return selected ? (
        <HeaderButtonSelected onClick={onClick} children={children} sx={sx} />
      ) : (
        <HeaderButton onClick={onClick} children={children} sx={sx} />
      );
    case HeaderButtons.HEADER_MY_ADDRESSES:
      return (
        <MyAddressesButton
          onClick={onClick}
          children={children}
          sx={sx}
          startIcon={startIcon}
        />
      );
    case NewHomeButtons.WHITE:
      return (
        <NewHomeWhiteButton
          onClick={onClick}
          children={children}
          sx={sx}
          endIcon={endIcon}
        />
      );
    case HeaderButtons.HEADER_MY_ADDRESSES_COPY:
      return (
        <MyAddressesCopyButton onClick={onClick} children={children} sx={sx} />
      );
    case "add-new":
      switch (size) {
        default:
        case "m":
          return <ActionButton onClick={onClick} children={children} sx={sx} />;
        case "s":
          return (
            <ActionButtonSmall onClick={onClick} children={children} sx={sx} />
          );
        case "filledCard":
          return (
            <ActionButtonFilledCard
              onClick={onClick}
              children={children}
              sx={sx}
            />
          );
      }
    case "cancel":
      switch (size) {
        default:
        case "s":
          return (
            <CancelButtonSmall onClick={onClick} children={children} sx={sx} />
          );
      }
    case "remove":
      switch (size) {
        case "s":
          return (
            <RemoveButtonSmall onClick={onClick} children={children} sx={sx} />
          );
        default:
        case "m":
          return <>TODO</>;
        case "l":
          return <>TODO</>;
      }
    case "order-popup-close":
      return (
        <Button variant={"text"} onClick={onClick}>
          <BarekamIcon variant={IconVariants.close} />
        </Button>
      );
    case OrderButtons.ORDER_SUMMARY:
      return disabled ? (
        <OrderSummaryButtonDisabled
          onClick={onClick}
          children={children}
          disabled
          sx={sx}
        />
      ) : (
        <OrderSummaryButton onClick={onClick} children={children} sx={sx} />
      );
    case OrderButtons.PAY_NOW:
      return (
        <OrderPopupPayButton
          onClick={onClick}
          children={children}
          disabled={disabled}
          sx={sx}
        />
      );
    case OrderButtons.EXPORT:
      return (
        <OrderExportButton onClick={onClick} children={children} sx={sx} />
      );
    case OrderButtons.ADD_PRODUCT:
      return (
        <OrderAddProductButton onClick={onClick} children={children} sx={sx} />
      );
    case OrderButtons.WAREHOUSE_CARD:
      return (
        <OrderWarehouseCardButton
          onClick={onClick}
          children={children}
          sx={sx}
        />
      );
    case FilterButtons.CHIP_CLEAR_ALL:
      return (
        <ChipClearAll
          variant={"text"}
          onClick={onClick}
          children={children}
          sx={sx}
        />
      );
    case AuthButtons.MAIN:
      return <AuthButton onClick={onClick} children={children} sx={sx} />;
    case AuthButtons.TYPE_SELECT:
      return (
        <AuthTypeSelectButton onClick={onClick} children={children} sx={sx} />
      );
    case FilterButtons.MAIN_BUTTON:
      return selected ? (
        <FilterButtonOpened onClick={onClick} children={children} sx={sx} />
      ) : (
        <FilterButton onClick={onClick} children={children} sx={sx} />
      );
    case FilterButtons.SECONDARY_BUTTON:
      return selected ? (
        <FilterButtonSecondaryOpened
          onClick={onClick}
          children={children}
          sx={sx}
        />
      ) : (
        <FilterButtonSecondary onClick={onClick} children={children} sx={sx} />
      );
    case "new-parcel-add":
      switch (size) {
        default:
        case "m":
          return (
            <NewOrderAddButton onClick={onClick} children={children} sx={sx} />
          );
        case "s":
          return (
            <NewOrderAddButtonSmall
              onClick={onClick}
              children={children}
              sx={sx}
            />
          );
      }
    case RecipientButtons.RECIPIENT_EDIT:
      return (
        <RecipientEditButton onClick={onClick} children={children} sx={sx} />
      );
    case DialogButtons.CANCEL:
      return (
        <DialogCancelButton onClick={onClick} children={children} sx={sx} className={className} />
      );
    case DialogButtons.SAVE:
      return <DialogSaveButton onClick={onClick} children={children} sx={sx} />;
    case DialogButtons.DELETE:
      return (
        <DialogDeleteButton onClick={onClick} children={children} sx={sx} />
      );
    case DialogButtons.OK:
      return <DialogOkButton onClick={onClick} children={children} sx={sx} />;
    case AddressCardButtons.NEW_ADDRESS_ADD:
      return (
        <NewAddressAddButton onClick={onClick} children={children} sx={sx} />
      );
    case BalanceButtons.NEW_CARD:
      return selected ? (
        <NewCardButtonSelected onClick={onClick} children={children} sx={sx} />
      ) : (
        <NewCardButton onClick={onClick} children={children} sx={sx} />
      );
    case "input-with-select":
      return (
        <InputWithSelectButton
          onClick={onClick}
          children={children}
          disableRipple
          sx={sx}
        />
      );
    case SimpleButtons.LINK:
      return (
        <LinkButton
          variant={"text"}
          onClick={onClick}
          children={children}
          sx={sx}
          disableRipple
        />
      );
    case SimpleButtons.TEXT:
      return (
        <TextButton
          variant={"text"}
          onClick={onClick}
          children={children}
          sx={sx}
          disableRipple
        />
      );
    case SimpleButtons.TERMS_AND_CONDITIONS:
      return (
        <TermsAndConditionsButton
          variant={"text"}
          onClick={onClick}
          children={children}
          sx={sx}
        />
      );
    case CalendarButtons.FILTER:
      return selected ? (
        <CalendarButtonSelected
          variant={"text"}
          onClick={onClick}
          children={children}
          sx={sx}
        />
      ) : (
        <CalendarButton
          variant={"text"}
          onClick={onClick}
          children={children}
          sx={sx}
        />
      );
    case ParcelEditButtons.CANCEL:
      return (
        <ParcelEditDefaultButton
          variant={"text"}
          onClick={onClick}
          children={children}
          disabled={disabled}
          sx={sx}
        />
      );
    case ParcelEditButtons.REMOVE:
      return disabled ? (
        <ParcelEditDefaultButton
          variant={"text"}
          onClick={onClick}
          children={children}
          disabled={disabled}
          sx={sx}
        />
      ) : (
        <ParcelEditRemoveButton
          variant={"text"}
          onClick={onClick}
          children={children}
          disabled={disabled}
          sx={sx}
        />
      );
    case ParcelEditButtons.TO_ANOTHER_ORDER:
      return disabled ? (
        <ParcelEditDefaultButton
          variant={"text"}
          onClick={onClick}
          children={children}
          disabled={disabled}
          sx={sx}
        />
      ) : (
        <ParcelEditToAntherOrderButton
          variant={"text"}
          onClick={onClick}
          children={children}
          disabled={disabled}
          sx={sx}
        />
      );
    case ParcelEditButtons.NEW_ORDER:
      return disabled ? (
        <ParcelEditDefaultButton
          variant={"text"}
          onClick={onClick}
          children={children}
          disabled={disabled}
          sx={sx}
        />
      ) : (
        <ParcelEditCreateNewOrderButton
          variant={"text"}
          onClick={onClick}
          children={children}
          disabled={disabled}
          sx={sx}
        />
      );
    case ParcelEditButtons.ADD_DESCRIPTION:
      return (
        <ParcelEditAddDescriptionButton
          variant={"text"}
          onClick={onClick}
          children={children}
          disabled={disabled}
          sx={sx}
        />
      );
    case AdditionalServiceButtons.CHOOSE:
      return selected ? (
        <DefaultNewOrderSelectedButton
          variant={"text"}
          onClick={onClick}
          children={children}
          sx={sx}
        />
      ) : (
        <NewOrderChooseButton
          variant={"text"}
          onClick={onClick}
          children={children}
          sx={sx}
        />
      );
    case AdditionalServiceButtons.PROCEED:
      return (
        <NewOrderProceedButton
          variant={"text"}
          onClick={onClick}
          children={children}
          sx={sx}
        />
      );
    case ActionbarButtons.NEW:
      return size === "s" ? (
        <ActionButtonSmall
          onClick={onClick}
          children={children}
          sx={sx}
          endIcon={endIcon}
        />
      ) : (
        <ActionButton
          onClick={onClick}
          children={children}
          sx={sx}
          endIcon={endIcon}
        />
      );
    case CalculateButtons.CALCULATE:
      return <CalculateButton onClick={onClick} children={children} sx={sx} />;
    case MonthlyLimitsButtons.REMOVE:
      return (
        <MonthlyLimitsRemoveButton
          onClick={onClick}
          children={children}
          sx={sx}
        />
      );
    case MonthlyLimitsButtons.SET:
      return (
        <MonthlyLimitsSetButton onClick={onClick} children={children} sx={sx} />
      );
    default:
      return null;
  }
};

export default BarekamButton;

interface BarekamButtonProps {
  type:
    | SimpleButtons
    | RecipientButtons
    | HeaderButtons
    | AuthButtons
    | SidebarButtons
    | DialogButtons
    | OrderButtons
    | CalendarButtons
    | FilterButtons
    | ParcelEditButtons
    | AdditionalServiceButtons
    | ActionbarButtons
    | CalculateButtons
    | AddressCardButtons
    | MonthlyLimitsButtons
    | BalanceButtons
    | NewHomeButtons
    | "auth-action"
    | "received"
    | "sent"
    | "state"
    | "tab"
    | "add-new"
    | "cancel"
    | "remove"
    | "order-popup-close"
    | "new-parcel-add"
    | "input-with-select";
  onClick: MouseEventHandler<HTMLButtonElement>;
  size?: "s" | "m" | "l" | "filledCard" | "outlinedCard";
  selected?: boolean;
  active?: boolean;
  startIcon?: string; // TODO: check is needed
  endIcon?: ReactElement<any, any>;
  disabled?: boolean;
  children?: React.ReactNode;
  theme?: Theme;
  sx?: SxProps;
  className?: string;
}
